import React, { useState, useEffect } from "react";
import { Frame, ScalingContainer } from "../../../AppStyled";
// import BallsGrid from "./BallsGrid";
import { Header, Loader } from "./styledBetReplay";
import Results from "./Results";
import { InfoPair, InfoTrio, Button } from "./SecondPage.js";
import { discoverWinnerBalls, winnerBallObjects } from "./helperFunctions";
import useSound from "use-sound";
import { logger } from '../../../App'
import goForward from "../../../audio/goForward.mp3";

export default function BetReplay({
  betReplyData,
  handleBetReply,
  unBlur,
  scrollable,
  h,
  handleAbove,
  userSettings,
  handleNotification,
  volume,
  sound,
  prec
}) {
  const {
    bet_id,
    selectedNumbers,
    numbers,
    betAmount,
    winCoef,
    winAmount,
    currency,
    client_seed,
    server_seed,
    server_seed_SHA256,
    nonce,
  } = betReplyData;

  useEffect(() => {
    return () => {
      handleBetReply({});
    };
  }, [handleBetReply]);

  const [goForwardSfx] = useSound(goForward, { volume });

  const [animSG, setanimSG] = useState(false);
  const [clicked, setclicked] = useState(false);
  // const resultBalls
  logger.log(betReplyData, "betReplyData");
  const choosenBalls = discoverWinnerBalls(
    selectedNumbers ? selectedNumbers : [],
    numbers ? numbers : []
  );
  const winnerBalls = winnerBallObjects(numbers ? numbers : []);

  return (
    <Frame
      className="BetReplayFrame"
      data-test="betreplay"
      unBlur={unBlur}
      scrollable={scrollable}
    >
      <ScalingContainer
        className="ScalingContainer"
        h={h}
        style={{ overflow: "scroll", scrollbarWidth: "none" }}
      >
        <Header
          name="BET REPLY"
          userSettings={userSettings}
          handleAbove={handleAbove}
          volume={volume}
          sound={sound}
        />
        {bet_id ? (
          <>
            <InfoPair title="Bet ID" text={bet_id} />
            <Results text="Result" balls={winnerBalls} />
            <Results text="Chosen balls" balls={choosenBalls} />
            <InfoTrio
              betAmount={betAmount}
              winCoef={winCoef}
              winAmount={winAmount}
              currency={currency}
              prec={prec}
            />
            <InfoPair
              title="Client seed"
              text={client_seed}
              handleNotification={handleNotification}
              cursor
            />
            <InfoPair
              title={server_seed ? "Server seed" : "Server seed hash"}
              text={server_seed ? server_seed : server_seed_SHA256}
              handleNotification={handleNotification}
              cursor
            />
            <InfoPair
              title="Nonce"
              text={nonce}
              handleNotification={handleNotification}
              cursor
            />
            <div style={{ height: 57, marginBottom: 30 }}>
              <Button
                data-test="verifyTest"
                onClick={() => {
                  if (!clicked) {
                    setclicked(true);
                    if (sound) goForwardSfx();
                    setanimSG(true);
                    setTimeout(() => {
                      setclicked(false);
                      handleAbove("History");
                    }, 500);
                    logger.log("clicked");
                  }
                }}
                animSG={animSG}
              >
                <div className="yellow" />
                <div className="white" />
                OK
              </Button>
            </div>
          </>
        ) : (
          <Loader>
            <p className="loading">
              Loading
              <span />
              <span />
              <span />
            </p>
          </Loader>
        )}
      </ScalingContainer>
    </Frame>
  );
}

